export enum TransformationType {
  SCORE_FILTERING = 'SCORE_FILTERING',
  INDICATOR_TYPE = 'INDICATOR_TYPE',
  SAFELIST_LIBRARY = 'SAFELIST_LIBRARY',
}

export enum ScoreFilteringType {
  BENIGN = 'Benign',
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
}

export enum IndicatorType {
  IP4 = 'IP4',
  IP6 = 'IP6',
  CIDR_BLOCK = 'CIDR_BLOCK',
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  URL = 'URL',
  MD5 = 'MD5',
  SHA1 = 'SHA1',
  SHA256 = 'SHA256',
  REGISTRY_KEY = 'REGISTRY_KEY',
  SOFTWARE = 'SOFTWARE',
  BITCOIN_ADDRESS = 'BITCOIN_ADDRESS',
  PHONE_NUMBER = 'PHONE_NUMBER',
  DOMAIN = 'DOMAIN',
}

export type Transformation = Partial<Record<TransformationType, any[]>>;
